import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBots, fetchCategories } from "../../state/actions/catalogue";
import { setLoader } from "../../state/actions/loader";
import { getPageName } from "../../utils/general";
import CatalogView from "./CatalogView";


const CatalogContainer = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const catalogue = useSelector((state) => state.catalogue);
  const selectedDomain = useSelector((state) => state.domain.selectedDomain);
  const pathname = getPageName();

  useEffect(() => {
    window.document.title = "Applications";
    if(selectedDomain){
      if (pathname === "Catalog_Featured") {
        dispatch(setLoader(true));
        dispatch(fetchBots({ featured: true }, true));
      }
      else if (pathname === "Catalog_Categories") {
        dispatch(setLoader(true));
        dispatch(fetchCategories());
      }
      else;
    }
  }, [selectedDomain]);


  const props = {
    userId: user?.user?.userId,
    botSubscriptions: user?.botSubscriptions,
    bots: catalogue?.bots,
    companies: catalogue?.companies,
    categories: catalogue?.categories,
    searchResults: catalogue?.searchResults,
    searchKey: catalogue?.searchKey,
    selectedDomain,
  };

  return <CatalogView {...props} />;
};

export default CatalogContainer;
